import { WIDGET_TYPES } from "constants/widgets.type.const";

const getGuageTags = (attribute, tagsAsObj) => {
  let tag = { TagId: "", TagName: null, Units: null, Value: null };
  if (isNaN(attribute)) {
    tag = tagsAsObj[attribute];
  } else {
    tag.Value = +attribute;
  }
  return tag;
};

const getWidgetData = (widget, tagsAsObj) => {
  const { Attributes, SubType, Type, Id, Order } = widget;
  const Tag = Attributes.SystemTag;
  const Tags = [];
  if (Tag) {
    Object.values(Tag).forEach(tag => {
      if (tag !== null && tag !== "") {
        const itemData = tagsAsObj[tag];
        Tags.push(itemData);
      }
    });
  }
  return { Id, Type, SubType, Tags, Order };
};

const parseWidgetData = (widget, tagsAsObj) => {
  const tagData = getWidgetData(widget, tagsAsObj);
  if (widget.Type === WIDGET_TYPES.GAUGE) {
    const { LL, L, H, HH } = widget.Attributes;
    tagData.GaugeData = {
      LL: getGuageTags(LL, tagsAsObj),
      L: getGuageTags(L, tagsAsObj),
      H: getGuageTags(H, tagsAsObj),
      HH: getGuageTags(HH, tagsAsObj)
    };
  } else if (widget.Type === WIDGET_TYPES.TIMESERIES) {
    tagData.Duration = widget.Attributes?.Duration;
  }
  return tagData;
};

export default parseWidgetData;
